module.exports = __webpack_public_path__ + "media/roast_website.5fec4c2e.mp4";